import { render, staticRenderFns } from "./InvestigationModal.vue?vue&type=template&id=e098c960&"
import script from "./InvestigationModal.vue?vue&type=script&lang=ts&"
export * from "./InvestigationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports